import { apiJson } from './client';

export interface ConductorLifetimeTurn {
  id: string;
  source: 'account' | 'snapshot' | 'session';
  sessionId: string | null;
  role: 'user' | 'assistant';
  content: string;
  status: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  sortMicros: string;
  sourceRank: number;
  causalOrder: string;
}

export interface ConductorLifetimePage {
  turns: ConductorLifetimeTurn[];
  nextCursor: string | null;
  hasMore: boolean;
}

export const conductorHistoryApi = {
  page(cursor: string | null = null): Promise<ConductorLifetimePage> {
    const params = new URLSearchParams({ scope: 'lifetime', limit: '80' });
    if (cursor) params.set('cursor', cursor);
    // apiJson already prefixes VITE_API_BASE_URL (normally `/api`).
    return apiJson<ConductorLifetimePage>(`/ceo/conversation?${params.toString()}`);
  },
};
